<template>
  <div :class="isShow?'bot-banner-container':'display_none'">
    <!-- <img class="bot-banner-logo" src="@/assets/img/au_logo_text.png" alt="" /> -->
    <img class="bot-banner-logo" src="@/assets/img/wutong_logo.png" alt="" />
    <div class="routerLink">
      <span class="jumpItem" @click="$router.push('/products-solutions')"
        >Products & Solutions</span
      >
      <span class="divider">|</span>
      <span class="jumpItem" @click="$router.push('/affiliates')"
        >Affiliates</span
      >
      <span class="divider">|</span>
      <span class="jumpItem" @click="$router.push('/contact')">Contact</span>
      <span class="divider">|</span>
      <span class="jumpItem" @click="$router.push('/faq')">FAQ </span>
    </div>
    <div class="contactWay">
      <!-- 0800 377 366 <span class="divider">|</span> +64 9 302 3246
      <span class="divider">|</span> -->
      info@auskyco.com
    </div>
    <div class="copyRight">
      <span class="opacity50"
        >United AU Pty Ltd, {{getThisYear}} © All Rights Reserved.</span
      >
      <span class="term">
        <span class="jumpItem" @click="$router.push('/privacy-policy')">Privacy Policy</span>
         | <span class="jumpItem" @click="$router.push('/terms-of-service')">Terms of Service</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    getThisYear () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.display_none{
  display: none;
}
.bot-banner-container {
  background: #163257;
  box-sizing: border-box;
}
.bot-banner-logo {
  display: block;
  margin: 0 auto;
  height: 12rem;
}
.routerLink {
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
}
.divider {
  margin: 0 24px;
}
.contactWay {
  margin-top: 14px;
  opacity: 0.5;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
}
.copyRight {
  margin-top: 30px;
  font-size: 14px;
  text-align: center;
  align-items: center;
}
.term {
  color: #dbb76b;
  margin-left: 16px;
}
.opacity50 {
  opacity: 0.5;
  color: #ffffff;
}
.jumpItem {
  cursor: pointer;
}
@media only screen and (max-width: 600px) {
  .bot-banner-container {
  height: auto;
  background: #163257;
  padding: 1vh 0 2vh;
}
.bot-banner-logo {
  display: block;
  margin: 0 auto;
  width: 30vw;
  height: auto;
}
.routerLink {
  margin-top: 0;
  font-size: 0.75rem;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
}
.divider {
  margin: 0 2vw;
}
.contactWay {
  margin-top: 0;
  opacity: 0.5;
  font-size: 0.75rem;
  color: #ffffff;
  text-align: center;
}
.copyRight {
  margin-top: 0;
  font-size: 0.75rem;
  text-align: center;
  align-items: center;
}
.term {
  color: #dbb76b;
  margin-left: 0;
  display: block;
}
}
</style>
